// -------------------------------
// ESIC DISABLEMENT INTERFACES
// -------------------------------
export interface PendingDisablement {
    name?: string;
    description?: string;
}

export interface PendingDeleteDisablement {
    awaitingName?: boolean;
}

// -------------------------------
// CREATE DISABLEMENT — START
// -------------------------------
export const startCreateDisablementFlow = (
    setPending: (data: PendingDisablement | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        setPending({ name: nameFromIntent });

        pushAIChat(`Any description for "${nameFromIntent}"?`);
        speak(`Any description for ${nameFromIntent}?`);
        return;
    }

    setPending({});
    pushAIChat("Sure! What should the disablement type be called?");
    speak("What should the disablement type be called?");
};

// -------------------------------
// CREATE DISABLEMENT — PROCESS
// -------------------------------
export const processPendingDisablement = (
    text: string,
    pending: PendingDisablement,
    setPending: (data: PendingDisablement | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // STEP 1 — NAME
    if (!pending.name) {
        const cleanName = text.replace(/[^a-zA-Z0-9 ]/g, "").trim();

        if (!cleanName) {
            pushAIChat("Please provide a valid disablement type name.");
            speak("Please provide a valid disablement type name.");
            return;
        }

        setPending({ ...pending, name: cleanName });

        pushAIChat("Any description for this disablement type?");
        speak("Any description?");
        return;
    }

    // STEP 2 — DESCRIPTION
    if (pending.description === undefined) {
        const description = text?.trim() || "";

        pushAIChat(`Perfect! Creating disablement type "${pending.name}"...`);
        speak(`Creating disablement type ${pending.name}.`);

        window.dispatchEvent(
            new CustomEvent("ai-create-esic-disablement", {
                detail: {
                    name: pending.name,
                    description
                }
            })
        );

        setPending(null);
        return;
    }
};

// -------------------------------
// DELETE DISABLEMENT — START
// -------------------------------
export const startDeleteDisablementFlow = (
    setPendingDelete: (data: PendingDeleteDisablement | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        pushAIChat(`Deleting disablement type "${nameFromIntent}"...`);
        speak(`Deleting disablement type ${nameFromIntent}.`);

        window.dispatchEvent(
            new CustomEvent("ai-delete-esic-disablement", {
                detail: { name: nameFromIntent }
            })
        );
        return;
    }

    setPendingDelete({ awaitingName: true });
    pushAIChat("Which disablement type would you like to delete?");
    speak("Which disablement type would you like to delete?");
};

// -------------------------------
// DELETE DISABLEMENT — PROCESS
// -------------------------------
export const processPendingDeleteDisablement = (
    text: string,
    pending: PendingDeleteDisablement,
    setPendingDelete: (data: PendingDeleteDisablement | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pending.awaitingName) return;

    const cleanName = text.replace(/[^a-zA-Z0-9 ]/g, "").trim();

    if (!cleanName) {
        pushAIChat("Please provide a valid disablement type name.");
        speak("Please provide a valid disablement type name.");
        return;
    }

    pushAIChat(`Deleting disablement type "${cleanName}"...`);
    speak(`Deleting disablement type ${cleanName}.`);

    window.dispatchEvent(
        new CustomEvent("ai-delete-esic-disablement", {
            detail: { name: cleanName }
        })
    );

    setPendingDelete(null);
};